import { styled } from '@volkswagen-onehub/components-core';

export const StyledGalleryViewerCarousel = styled.div`
  background: linear-gradient(
      270deg,
      #dfe4e8 0.03%,
      rgba(223, 228, 232, 0) 99.97%
    ),
    radial-gradient(
      142.13% 82.4% at 0% 100%,
      #fff 0%,
      rgba(255, 255, 255, 0.44) 100%
    ),
    #dfe4eb;
  background-blend-mode: multiply, normal, normal;
`;
